import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentList = () => {
  return (
    <g>
      <path d="m14.3628.1875h-12.7256a.75.75 0 0 0 -.75.75v14.125a.75.75 0 0 0 .75.75h12.7256a.75.75 0 0 0 .75-.75v-14.125a.75.75 0 0 0 -.75-.75zm-.75 14.125h-11.2256v-12.625h11.2256z" />
      <path d="m6.895 6.0313h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z" />
      <path d="m4.28 6.09a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07.8924.8924 0 0 0 .54-.81.8947.8947 0 0 0 -.26-.62.92.92 0 0 0 -1.24 0 .8834.8834 0 0 0 -.25.62.8542.8542 0 0 0 .54.81z" />
      <path d="m4.28 8.81a.9292.9292 0 0 0 .33.07.98.98 0 0 0 .34-.07 1.0578 1.0578 0 0 0 .28-.19.8719.8719 0 0 0 .26-.62.7543.7543 0 0 0 -.07-.33.81.81 0 0 0 -.19-.29.9018.9018 0 0 0 -.95-.19.9414.9414 0 0 0 -.48.48.916.916 0 0 0 -.06.33.87.87 0 0 0 .26.62.9127.9127 0 0 0 .28.19z" />
      <path d="m6.895 8.75h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z" />
      <path d="m3.99 11.34a.9035.9035 0 0 0 .62.25.9934.9934 0 0 0 .34-.06 1.085 1.085 0 0 0 .28-.19.81.81 0 0 0 .19-.29.726.726 0 0 0 .07-.33.8.8 0 0 0 -.07-.34.8744.8744 0 0 0 -.19-.28.8736.8736 0 0 0 -1.24 0 .8355.8355 0 0 0 -.18.28.7933.7933 0 0 0 -.07.34.8788.8788 0 0 0 .06.33.9634.9634 0 0 0 .19.29z" />
      <path d="m6.895 11.4688h4.5723a.75.75 0 0 0 0-1.5h-4.5723a.75.75 0 0 0 0 1.5z" />
    </g>
  );
};

export default withIcon(IconDocumentList);
